import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        color: 'white',
      },
    },
  },
  colors: {
    blue: {
      400: '#DFDFDF',
      500: '#1F5673',
    },
  },
  fonts: {
    heading: `'Roboto Slab', serif`,
    body: `'Roboto Slab', serif`,
  },
})
